export default __webpack_public_path__ + "static/media/icon-people-light.a022edf7.svg";